import React from "react";
import { Parah, SubTitle } from "../ContentsStyles";

const CG_13 = () => {
  return (
    <>
      <Parah>
        The goal of the For You feed (FYF) is to provide original content that
        honours our mission of inspiring creativity and bringing joy to our
        diverse community around the world. Each account holder’s FYF is based
        on a personalized recommendation system. Our recommendation system is
        designed with user safety as a primary consideration, meaning that some
        content may not be eligible for recommendation. While the spontaneity of
        the FYF is what makes Talents Explore unique, the FYF is intended for a
        general audience that includes everyone from our teenage users to great
        grandparents. We consider the breadth of our audience when we determine
        what content is eligible for algorithmic promotion on the platform.
        Provided that it does not violate local laws, the following types of
        content may be allowed on our platform, searchable, and viewed in
        Following feeds but not eligible for recommendation.
      </Parah>
      <SubTitle>Minor Safety</SubTitle>
      <Parah>
        Minors’ sense of judgment and identity mature as they develop. To
        provide teens with additional room for identity exploration and
        expression in digital spaces, content uploaded by users under the age of
        16 is not eligible for recommendation. We strive to encourage healthy
        development across all ages. The promotion of cosmetic surgery to minors
        may lead to higher rates of body dissatisfaction. Accordingly, such
        content -- including before-and-after videos, videos of surgical
        procedures, and messages discussing elective cosmetic surgery without
        warning of risks -- are ineligible for the FYF of all users under the
        age of 18.
      </Parah>
      <SubTitle>Dangerous Stunts and Sports</SubTitle>
      <Parah>
        Certain activities can be risky or dangerous when replicated without
        safety precautions, which could lead to physical harm. Content that
        includes dangerous stunts, or extreme sports performed by
        non-professionals, may be ineligible. (We remove content that depicts
        dangerous acts and challenges performed by non-professionals, which may
        lead to serious injury or death for the user or the public).
      </Parah>
      <SubTitle>Overtly Sexualized Content</SubTitle>
      <Parah>
        We are mindful that not all content may be suitable for all users
        (particularly our teenage users) and/or may be culturally inappropriate
        in certain regions. To help maintain a comfortable and age-appropriate
        experience, content that is overtly sexually suggestive may not be
        eligible for recommendation. This would include content that depicts
        implied nudity, sexualizes body parts, or is blatantly erotic or sensual
        (e.g., strip teases).
      </Parah>
      <SubTitle>Tobacco and Alcohol Products</SubTitle>
      <Parah>
        Talents Explore is deeply committed to protecting the safety of minors
        on our platform. Content promoting, mentioning, or depicting alcohol
        products consumed by persons of legal drinking age but done so in a
        dangerous fashion may not be eligible for recommendation. Content
        depicting the use of tobacco products by adults or mentioning controlled
        substances is not eligible for recommendation. Please remember that
        content which suggests, depicts, imitates, or promotes the possession or
        consumption of alcoholic beverages, tobacco, or drugs by a minor is
        prohibited. Content that offers instruction targeting minors on how to
        buy, sell, or trade alcohol, tobacco, or controlled substances is
        prohibited per our Community Guidelines as well.
      </Parah>
      <SubTitle>Violent and Graphic Content</SubTitle>
      <Parah>
        Our community celebrates creativity, but shock value isn't everyone's
        preference. Content that can cause discomfort, shock or disgust to
        viewers may be ineligible for the FYF, including scary effects, jump
        scares, makeup that realistically replicates gory wounds, or depictions
        of bodily functions. Most violent and graphic content is not allowed on
        Talents Explore; however, in certain situations we may not remove some
        types of this content such as depictions of graphic deaths, accidents or
        fighting when real world events are being documented and it is in the
        public interest. Since this content isn't appropriate for all audiences,
        it will not be eligible for recommendation and the content will include
        an “opt-in” screen or warning.
      </Parah>
      <SubTitle>Spam, Inauthentic, or Misleading Content</SubTitle>
      <Parah>
        We value authenticity and accuracy. We make ineligible for the FYF any
        content that tricks or manipulates users to inauthentically increase
        followers, likes, views, or other engagement metrics on the platform,
        including follow-to-follow, like-to-like, and misleading or manipulating
        users into clicking like or share buttons. Conspiratorial content that
        counters generally accepted beliefs and casts blame on a group or entity
        (rather than any living individual) or that includes potentially
        misleading and harmful content about current, unfolding events where
        details are still developing, are also ineligible for recommendation.
      </Parah>
      <SubTitle>Unoriginal, Low-quality, and QR Code Content</SubTitle>
      <Parah>
        Original and entertaining content form the core of the Talents Explore
        community. To maintain the positive experience our users expect from the
        Talents Explore platform, unoriginal and low-quality content is
        ineligible for recommendation. We consider content not original if it is
        imported or uploaded from Talents Explore, other platforms, or other
        sources including television, movies, or webcasts, and the user has not
        added new, creative edits. One indicator that the content is not
        original is a visible watermark or superimposed logo. Low quality
        content includes extremely short clips, static images, and
        exclusively-GIF based videos. Content that includes QR codes is usually
        ineligible for the FYF because it can lead users to harmful websites or
        apps, though we make exceptions in certain circumstances where that risk
        is low.
      </Parah>
      <Parah>
        Thank you for being a part of our vibrant global community and working
        with us to maintain a welcoming space for all users. If you come across
        content or accounts that you believe may violate our Community
        Guidelines, please let us know so we can review and take appropriate
        action.
      </Parah>
    </>
  );
};

export default CG_13;
